module.exports = __webpack_public_path__ + "img/IMG_1458_L_Wood.8005caef.jpg";